import { PeriodoGetModelo115DtoProps } from "api/DTOs/PeriodoGetModelo115Dto"
import { formatCurrency } from "common/utils/currency"
import { TFunction } from "i18next"
import { MODELO_IMPUESTO } from "../../../../../../api/Types/ModeloImpuesto"
import * as ROUTES from "../../../../../../routes/RoutePaths"
import { TEXTO_TRIMESTRE } from "../../constants/textoTrimestre"
import { RedirectParams } from "../constants"

export const MODELO_115_COLUMNS = (
  t: TFunction,
  navigate: ({ route, periodo, modelo, year }: RedirectParams) => void,
  selectedYear: string
) => {
  const columns = [
    {
      header: `${t("taxSummary.tables.period")}`,
      field: "periodo",
      key: "periodo",
      style: { width: "30%" },
      body: ({ periodo }: PeriodoGetModelo115DtoProps) =>
        periodo ? TEXTO_TRIMESTRE(t)[periodo] : "Total",
    },
    {
      header: `${t("taxSummary.tables.retentionRent")}`,
      field: "importe",
      key: "importe",
      alignCol: "right",
      style: { width: "30%" },
      bodyClassName: "!tw-w-auto !tw-text-end",
      body: (rowData: PeriodoGetModelo115DtoProps) => {
        const isRedirect = rowData?.importe !== 0 && rowData?.periodo
        return (
          <span
            className={isRedirect ? "!tw-text-info hover:tw-underline" : ""}
            onClick={() =>
              isRedirect &&
              navigate({
                route: `${ROUTES.RESUMEN_IMPUESTOS}/${MODELO_IMPUESTO.MODELO_115}`,
                periodo: rowData?.periodo,
                modelo: MODELO_IMPUESTO.MODELO_115,
                year: selectedYear,
              })
            }
          >
            {formatCurrency(rowData?.importe ?? 0)}
          </span>
        )
      },
    },
  ]

  return columns
}
